<div class="row mb-2">
  <div class="col-12">

    <ejs-tab #tabObj
              Selecting="Select"
              id="element"
              class="mt-2"
              heightAdjustMode="fill"
              [animation]="animation"
              (selected)="onTabSelected($event)"
              (created)="tabGroupCreated()"
              (added)="setTabBarWidth()">
      <e-tabitems>
        <!-- Tab items will be added dynamically -->
      </e-tabitems>
    </ejs-tab>
    <!-- Tab content will be added dynamically-->
    <ng-template #tabContent></ng-template>

    <div class="buttons-tab-management" [ngStyle]="{'left.px': tabBarWith + 21 }" [hidden]="!isEditMode">
      <div class="d-flex">
        <button class="btn btn-tab-management" (click)="openTabSettings()" title="{{'i18n.domain.home.dashboard.edit-tab' | translate}}">
          <span class="e-icons icon-settings"></span>
        </button>
      </div>
    </div>

    <div class="buttons-top-right">
      <div class="d-flex">
        <button class="btn btn-secondary me-2" (click)="refreshWidgetData()" [hidden]="isEditMode" title="{{'i18n.domain.home.dashboard.reload-dashboard' | translate}}">
          <span class="e-icons icon-reset"></span>
        </button>
        <button class="btn btn-secondary me-2" (click)="addWidget()" [hidden]="!isEditMode" title="{{'i18n.domain.home.dashboard.add-widget' | translate}}">
          <span class="e-icons icon-add"></span>
        </button>
        <button class="btn btn-primary" (click)="toggleEditMode()" title="{{isEditMode ? ('i18n.domain.home.dashboard.normal-view' | translate) : ('i18n.domain.home.dashboard.edit' | translate)}}">
          @if (!isEditMode) {
            <span class="e-icons icon-settings"></span>
          }
          @if (isEditMode) {
            <span class="e-icons icon-checkmark"></span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
<app-tab-settings #editTabsWidgetDialog (closeTabSettingsWidget)="setTabBarWidth()"></app-tab-settings>
